import {DomainEvent} from './DomainEvent';
import {Video} from '../resources/Video';

export abstract class VideoEvent extends DomainEvent<Video> {}
